import React from 'react';
import * as T from './types';
import * as S from './styles';

const TextToolTip: React.FC<T.IProps> = (props) => {

  return (
    <S.Root style={props.style} >
      {props.children}
      {
        props.tip &&
        <S.TextBox style={props.boxStyle} >
          <S.TextTitle style={props.textStyle} >
            {props.tip}
          </S.TextTitle>
        </S.TextBox>
      }
    </S.Root>
  );
}

export default TextToolTip;